import React from 'react';
import styles from './Wrapper.module.scss';
import { AppContextProvider } from '../context/AppContext';

interface WrapperProps {
  children: React.ReactNode;
  serverUrl: string;
  stage: string;
  locale: string;
  listingsVibeFirst?: boolean;
}

export const Wrapper = ({ children, serverUrl, stage, locale, listingsVibeFirst = false }: WrapperProps) => {
  return (
    <AppContextProvider serverUrl={serverUrl} stage={stage} locale={locale}>
      <div className={styles.root} data-listings-vibe-first={listingsVibeFirst ? 'true' : undefined}>
        {children}
      </div>
    </AppContextProvider>
  );
};
